export default __webpack_public_path__ + "static/media/V2_Política_Protección_DatosAPP_AECE.9e0123bc.pdf";